import { useState } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container } from '@crehana/ui';
// eslint-disable-next-line no-restricted-imports
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';

import ChatTips from './components/ChatTips';
import FormBySteps from './components/FormBySteps';
import LoaderFinalStep from './components/LoaderFinalStep';
import FormStepsContextProvider from './context/FormStepsContext';

const TrialFormSection = () => {
  const [isLastStep, setIsLastStep] = useState(false);

  return (
    <Container
      className="relative"
      css={css`
        margin-top: 122px;
        ${({ theme }) => theme.breakpoints.up('sm')} {
          margin-top: 144px;
        }
      `}
    >
      <FormStepsContextProvider>
        {isLastStep ? (
          <LoaderFinalStep />
        ) : (
          <>
            <ChatTips />
            <FormBySteps setLastStep={() => setIsLastStep(true)} />
          </>
        )}
      </FormStepsContextProvider>
    </Container>
  );
};

export default TrialFormSection;
